import download from "downloadjs";
import { useCallback } from "react";
import toast from "react-hot-toast";

const useDownloadDocument = () => {
  const enCodeUrl = useCallback((url: string) => {
    const extension = url.split(".").pop();
    return extension;
  }, []);

  const downloadDocument = async (url: string, name: string) => {
    try {
      const newName = `${name}.${enCodeUrl(url)}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error("Network error while downloading");
      const dataBlob = await res.blob();
      const contentType = res.headers.get("content-type") || undefined;
      const newBlob = contentType
        ? new Blob([dataBlob], { type: contentType })
        : dataBlob;
      download(newBlob, newName);
      toast.success("Documento descargado satisfactoriamente.");
    } catch (error) {
      toast.error("Error al descargar el archivo, intente nuevamente.");
    }
  };

  return { downloadDocument };
};

export default useDownloadDocument;
